
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { bodegasXGranja, startBodegaXID, startListadoBodegas } from "../../../services";






export const useBodegaXID = (id) => {
    const bodegaXIDQuery = useQuery({
        queryKey: ['bodega-id', id], 
        queryFn: () => startBodegaXID(id),
    });

    return {
        bodegaXIDQuery
    }
}



export const useBodegaXGranja = (id) => {
    const bodegaXGranjaQuery = useQuery({
        queryKey: ['bodega-xgranja', id], 
        queryFn: () => bodegasXGranja(id),
        enabled: !!id,
    });

    return {
        bodegaXGranjaQuery,
    }
}




export const useBodegasQuery = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const bodegasListQuery = useQuery({
        queryKey: ['bodega-list', { page, termino }], 
        queryFn: () => startListadoBodegas({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        bodegasListQuery,
    }
}
